import script from "./CreatingFont.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatingFont.vue?vue&type=script&setup=true&lang=js"

import "./CreatingFont.vue?vue&type=style&index=0&id=c2db5e8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2db5e8a"]])

export default __exports__